<template>
    <div>
        <app-dialog v-show="showDialog" :value="isPaymentMethodDialogOpen" @input="tryClose($event)" :title="$t('payment.title')" width="40vw" :isPersistent="true" data-cy="payment-method-dialog">
            <template v-slot:content>
                <v-overlay :value="isLoading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-list v-if="paymentMethodList" three-line v-bind:class="{ list_content_scroll: true,'payment-method-list':true }" style="margin-left: -25px; margin-right: -25px">
                    <v-list-item-group>
                        <template v-for="(method, index) in paymentMethodList">
                            <v-list-item :key="method.title" @click="confirm(method.slug)" v-if="showOption(method.slug)" :disabled="paymentMethodDisabled(method.slug)" :ripple="!isMbWay && !isMbRef" :inactive="isMbWay || isMbRef">
                                <v-list-item-avatar size="70" :tile="true">
                                    <v-img :src="getImage(method.image)"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title class="payment-method-title" v-html="tb(method.title)"></v-list-item-title>
                                    <v-list-item-subtitle class="payment-method-subtitle" v-html="tb(method.description)"></v-list-item-subtitle>

                                    <v-list-item-subtitle v-if="method.slug === 'mbway' && !isMbWayAvailable" class="font-size-md myprovet-list-title payment-method-subtitle dark-red-color">{{ $t('payment.aboveLimit') }}</v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="method.slug === 'ref-multibanco' && !isMbRefAvailable" class="font-size-md myprovet-list-title payment-method-subtitle dark-red-color">{{ $t('payment.belowMinimum') }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-divider v-if="index !== paymentMethodList.length - 1" :key="index" style="margin-left: 100px"></v-divider>
                        </template>
                    </v-list-item-group>
                </v-list>

                <div v-if="isMbWay">
                    <v-card class="mx-auto" max-width="400" outlined>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="7" class="pt-4 pb-0">
                                        <span class="text-overline">{{ $t('payment.countryCode') }}</span>
                                    </v-col>

                                    <v-col cols="5" class="pt-4 pb-0">
                                        <v-text-field class="quantity-counter-input" value="Portugal 351" outlined hide-details :readonly="true"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="7" class="py-0">
                                        <span class="text-overline">{{ $t('payment.phoneNumber') }}</span>
                                    </v-col>

                                    <v-col cols="5" class="py-0">
                                        <v-text-field class="quantity-counter-input right-input" v-model="phone" outlined hide-details autofocus></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="7" class="py-0">
                                        <span class="text-overline">{{ $t('payment.amountToPay') }}</span>
                                    </v-col>

                                    <v-col cols="5" class="py-0">
                                        <v-text-field class="quantity-counter-input right-input" :value="value" outlined hide-details :readonly="true"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="7" class="pt-0 pb-2"></v-col>

                                    <v-col cols="5" class="pt-0 pb-2">
                                        <v-btn text class="myprovet-btn-ok px-8" @click="validateMbWay()"> {{ $t('payment.pay') }} </v-btn>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" class="py-0">
                                        <v-list-item-subtitle style="-webkit-line-clamp: 5">{{ $t('payment.mbwayNotification') }}</v-list-item-subtitle>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" class="pt-0 pb-4">
                                        <v-list-item-subtitle style="-webkit-line-clamp: 5">{{ $t('payment.mbwayTimeout') }}</v-list-item-subtitle>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </div>

                <div v-if="isMbRef">
                    <v-card class="mx-auto" max-width="400" outlined>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="d-flex justify-space-between text-overline mb-2 px-4">
                                    <span>{{ $t('payment.entity') }}</span>
                                    <span class="font-weight-bold"> {{ entity }} </span>
                                </div>

                                <div class="d-flex justify-space-between text-overline mb-2 px-4">
                                    <span>{{ $t('payment.reference') }}</span>
                                    <span class="font-weight-bold"> {{ reference }} </span>
                                </div>

                                <div class="d-flex justify-space-between text-overline px-4">
                                    <span>{{ $t('campaigns.value') }}</span>
                                    <span class="font-weight-bold"> {{ value }} € </span>
                                </div>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </div>
            </template>

            <template v-slot:buttons>
                <v-btn text outlined class="myprovet-btn-cancel px-8" @click="tryClose($event)"> {{ $t('common.close') }} </v-btn>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { axios } from '@/Services/Backend';

export default {
    props: {
        isPaymentMethodDialogOpen: {
            default: false,
        },
        serie: {
            default: null,
            type: String,
        },
        document_number: {
            default: null,
            type: [Number, String],
        },
        document_id: {
            default: null,
            type: [Number, String],
        },
        invoice_id: {
            default: null,
            type: Number,
        },
        total: {
            default: null,
            type: [Number, String],
        },
        hideMbWay: {
            default: false,
            type: Boolean,
        },
        sendPaymentEmail: {
            default: true,
            type: Boolean,
        },
        redirect: {
            default: false,
            type: Boolean,
        },
    },

    data: () => ({
        isLoading: false,

        paymentMethodList: [],

        selectedPaymentMethod: null,
        isMbRef: false,
        isMbWay: false,
        payment: null,
        paymentLoaded: false,

        // @Note: MB Ref. variables
        entity: null,
        reference: null,
        value: null,
        originalValue: null,
        valueLoaded: false,
        mbRefLimit: 1,

        // @Note: MB Way variables
        mbWayLimit: null,
        phoneCode: '+351',
        phone: null,
    }),

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore),

        isMbRefPaymentProp() {
            return (this.payment && this.payment.type) === 'MBREF';
        },

        isMbWayPaymentProp() {
            return (this.payment && this.payment.type) === 'MBWAY';
        },

        isMbRefAvailable() {
            let cartTotal = this.originalValue;

            if (cartTotal === null) {
                cartTotal = this.normalOrderStore.getCartTotal;
            }

            return this.mbRefLimit && cartTotal >= this.mbRefLimit;
        },

        isMbWayAvailable() {
            let cartTotal = this.originalValue;
            if (cartTotal === null) {
                cartTotal = this.normalOrderStore.getCartTotal;
            }

            return this.mbWayLimit && cartTotal <= this.mbWayLimit;
        },

        showDialog() {
            return this.hideMbWay && this.entity === null && this.reference === null ? false : true;
        },

        wasPaid() {
            let was_paid = false;
            if ((this.payment && this.payment.type) === 'MBREF' && this.payment.was_paid) was_paid = true;
            if ((this.payment && this.payment.type) === 'MBWAY' && this.payment.was_paid && this.payment.status === '000') was_paid = true;

            return was_paid;
        },
    },

    watch: {
        isPaymentMethodDialogOpen: {
            handler: function (newValue) {
                if (newValue) {
                    this.isMbRef = false;
                    this.isMbWay = false;

                    if (this.total) this.originalValue = this.total;

                    if (this.isMbRefPaymentProp) {
                        this.entity = this.payment.entity;
                        this.reference = this.payment.reference;
                        this.value = this.payment.value;
                        this.originalValue = this.payment.originalValue;

                        this.isMbRef = true;
                    }

                    if (this.isMbWayPaymentProp) {
                        this.phone = this.payment.phone;
                        this.value = this.payment.value;

                        this.isMbWay = true;
                    }
                } else {
                    // @Note: Stays in the same page without redirecting the user to dashboard
                    if (!this.redirect) {
                        this.isMbRef = false;
                        this.isMbWay = false;
                        this.clearFields();

                        return;
                    }

                    // @Note: If MB Ref. was chosen and the dialog was closed, then we go back to dashboard page.
                    if (!this.invoice_id && (this.isMbRef || this.isMbWay)) this.$inertia.visit('/dashboard');
                }
            },
            immediate: true,
        },

        valueLoaded: {
            handler: function (value) {
                if (value) {
                    this.getPaymentInfo();
                }
            },
            immediate: true,
        },

        paymentLoaded: {
            handler: function (value) {
                if (value) {
                    if (this.payment) {
                        if (this.wasPaid) {
                            this.showSuccess(this.$t('payment.alreadyPaid'));
                            this.refresh();
                            return;
                        }

                        if (this.isMbWayPaymentProp && !this.payment.expired) {
                            this.showSuccess(this.$t('payment.awaitingMbway'));
                            return;
                        }
                    }

                    // @Note: there is no payment record generated.
                    if (this.selectedPaymentMethod === 'mbway') {
                        this.isMbWay = true;
                    } else if (this.selectedPaymentMethod === 'ref-multibanco') {
                        this.getMbReference();
                    }
                }
            },
            immediate: true,
        },

        hideMbWay: {
            handler: function (value) {
                if (value) {
                    this.selectedPaymentMethod = 'ref-multibanco';
                    this.getPaymentValue();
                }
            },
            immediate: true,
        },
    },

    methods: {
        getImage(img) {
            return '/storage/assets/payment-methods/' + img;
        },

        confirm(payment_method) {
            if (this.isMbRef || this.isMbWay) return;

            this.selectedPaymentMethod = payment_method;
            this.getPaymentValue();
        },

        tryClose() {
            if (this.isMbWay) {
                this.closeMbWay();
            } else {
                this.$emit('input', !this.isMbRef ? 'closedWithNoMethod' : false); // if no method was selected, we let the parent component know
            }
        },

        showOption(slug) {
            if (!this.isMbRef && !this.isMbWay) {
                return true;
            } else {
                if (slug === 'ref-multibanco' && this.isMbRef) {
                    return true;
                } else if (slug === 'mbway' && this.isMbWay) {
                    return true;
                }
            }

            return false;
        },

        paymentMethodDisabled(slug) {
            if (slug === 'mbway' && !this.isMbWayAvailable) return true;
            if (slug === 'ref-multibanco' && !this.isMbRefAvailable) return true;

            return false;
        },

        closeMbWay() {
            this.isMbRef = false;
            this.isMbWay = false;
            this.phone = null;
        },

        getPaymentMethods() {
            this.isLoading = true;

            axios
                .get('/api/orders/payment-methods')
                .then(({ data }) => {
                    this.isLoading = false;
                    this.mbWayLimit = data.mbWayLimit;
                    this.paymentMethodList = data.paymentMethods;
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.log(error);
                });
        },

        // @Note: This is done for security purposes
        getPaymentValue(valueLoadedIndicator = true) {
            this.valueLoaded = false;
            this.isLoading = true;

            this.clearFields();

            let params = {
                serie: this.serie,
                document_number: this.document_number,
                invoice_id: this.invoice_id,
            };

            axios
                .get('/api/orders/payment-value', { params })
                .then(({ data }) => {
                    this.isLoading = false;

                    if (data.value !== '') {
                        this.value = data.value + ' €';
                        this.originalValue = data.original_value;

                        if (valueLoadedIndicator) this.valueLoaded = true;
                    } else {
                        this.showError(this.$t('payment.unavailable'));
                        this.closeMbWay();
                    }
                })
                .catch((error) => {
                    this.isLoading = false;

                    console.log(error);
                    this.showError(this.$t('payment.unavailable'));
                    this.closeMbWay();
                });
        },

        getPaymentInfo() {
            this.paymentLoaded = false;
            this.isLoading = true;

            let params = {
                document_id: this.document_id,
            };

            axios
                .get('/api/orders/payment-info', { params })
                .then(({ data }) => {
                    this.isLoading = false;

                    this.payment = data.payment;
                    this.paymentLoaded = true;
                })
                .catch((error) => {
                    this.isLoading = false;

                    console.log(error);
                    this.showError(this.$t('payment.infoError'));
                });
        },

        getMbReference() {
            this.isLoading = true;

            let params = {
                branch_id: this.branchStore.branch.id,
                serie: this.serie,
                document_number: this.document_number,
                document_id: this.document_id,
                value: this.originalValue,
                send_email: this.sendPaymentEmail,
            };

            axios
                .get('/api/orders/mb-reference', { params })
                .then(({ data }) => {
                    this.isLoading = false;

                    if (!data.success) {
                        this.selectedPaymentMethod = null;
                        this.isMbRef = false;
                        this.isMbWay = false;

                        // @Note: Error. Don't show the real ifthenpay error message to the user
                        this.showError(data.message);

                        this.$emit('input', false);
                    } else {
                        // @Note: This is done for showing the order_value >= 1000000 warning
                        if (data.message !== '' && data.message !== 'Success') this.showError(data.message);

                        this.entity = data.entity;
                        this.reference = data.reference;
                        this.value = data.value;
                        this.payment = data.payment;

                        const showMessage = !window.location.pathname.startsWith('/orders/awaiting-payment');
                        if (!this.invoice_id) this.normalOrderStore.finishPurchase(showMessage);

                        this.isMbRef = true;
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.log(error);

                    this.showError(this.$t('payment.referenceError'));
                });
        },

        validateMbWay() {
            if (this.phone === null) {
                this.showError(this.$t('payment.phoneRequired'));
                return false;
            }

            const regex = /^\d{9}$/;
            if (!this.phone.match(regex)) {
                this.showError(this.$t('payment.phoneInvalid'));
                return false;
            }

            // @Note: Request MB WAY payment
            this.sendMbWayRequestPayment();

            return true;
        },

        sendMbWayRequestPayment() {
            this.isLoading = true;

            let params = {
                branch_id: this.branchStore.branch.id,
                serie: this.serie,
                document_number: this.document_number,
                document_id: this.document_id,
                phone_code: this.phoneCode,
                phone: this.phone,
                value: this.originalValue,
            };

            axios
                .get('/api/orders/mb-way-send-payment-request', { params })
                .then(({ data }) => {
                    this.isLoading = false;

                    // MB WAY payment request was sent successfully
                    if (data.status === '000') {
                        this.showSuccess(data.response_description);

                        const showMessage = !window.location.pathname.startsWith('/orders/awaiting-payment');
                        if (!this.invoice_id) this.normalOrderStore.finishPurchase(showMessage);

                        this.$emit('input', false);
                    } else {
                        this.showError(data.response_description);
                    }
                })
                .catch((error) => {
                    this.isLoading = false;

                    if (error.response.data.message) {
                        const data = JSON.parse(error.response.data.message);

                        this.showSuccess(data.response_description);
                        this.$emit('input', false);
                    } else {
                        this.showError(this.$t('payment.requestError'));
                    }
                });
        },

        clearFields() {
            this.payment = null;
            this.entity = null;
            this.reference = null;
            this.value = null;
            this.phone = null;

            // Fix the problem of showing the MBRef unavailable message
            if (!this.isLoading) this.originalValue = null;
        },
    },

    created() {
        this.getPaymentMethods();
    },
};
</script>

<style scoped>
.payment-method-title {
    /* Adds some padding to make the accent visible on words like "Referência" */
    padding-top: 5px;
}

.payment-method-subtitle {
    /* Adds the equivalent padding at the bottom of the subtitle just to keep it visually consistent*/
    padding-bottom: 5px;
}
</style>
